import FeeGroup from './FeeGroup';
import FeeGroupsProps from './FeeGroup.props';
import { getSelectedSelectedPersonalizedItems } from '@greystar/lib';

export default function FeeGroups(props: FeeGroupsProps) {
  const entries = Array.from(props.feeMap.entries());

  const filteredPersonalizedAddons = getSelectedSelectedPersonalizedItems(entries, 1);

  return (
    <>
      {filteredPersonalizedAddons.map(([groupName, fees]) => {
        const activeFeeGroups = fees.some((fee) => fee.activeCount > 0) || !props.isSummaryStep;
        return activeFeeGroups ? (
          <FeeGroup {...props} key={groupName} groupName={groupName} fees={fees} />
        ) : null;
      })}
    </>
  );
}
